"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.customFilterDropdown = exports.mainColumnsStyle = exports.fixedColumnsStyle = exports.containerStyles = void 0;

var _reactEmotion = require("react-emotion");

var containerStyles = function containerStyles(allFixed) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("position:relative;", allFixed && "\n    header::-webkit-scrollbar,\n    main::-webkit-scrollbar {\n      display: none;\n    }\n  ")
  );
};

exports.containerStyles = containerStyles;

var fixedColumnsStyle = function fixedColumnsStyle(side) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("position:absolute;top:0;", side, ":0;background:#fff;z-index:2;box-shadow:", side === 'left' ? '+' : '-', "3px 0 8px 0 rgba(51,63,82,0.12);")
  );
};

exports.fixedColumnsStyle = fixedColumnsStyle;

var mainColumnsStyle = function mainColumnsStyle(hasFixed) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)()
  );
};

exports.mainColumnsStyle = mainColumnsStyle;
var customFilterDropdown =
/*#__PURE__*/
(0, _reactEmotion.css)("padding:8px;border-radius:6px;background:#fff;box-shadow:0 1px 6px rgba(0,0,0,.2);");
exports.customFilterDropdown = customFilterDropdown;